import { render } from "./mobileAppBanner.vue?vue&type=template&id=488a739f&scoped=true"
import script from "./mobileAppBanner.vue?vue&type=script&lang=js"
export * from "./mobileAppBanner.vue?vue&type=script&lang=js"

import "./mobileAppBanner.vue?vue&type=style&index=0&id=488a739f&lang=scss&scoped=true"
import "./mobileAppBanner.vue?vue&type=style&index=1&id=488a739f&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488a739f"]])

export default __exports__